import request from '@/utils/request'

/**
 * 查询签到记录列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function querySignRecord(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/sign.querySignRecord',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
